// =============================================================================
// SERVICE ICON COMPONENT - SIMPLIFIED FONTICON ICONS
// =============================================================================

import React from 'react';

interface ServiceIconProps {
  icon: string;
  alt?: string;
  title?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  'aria-label'?: string;
  'aria-hidden'?: boolean;
}

export const ServiceIcon: React.FC<ServiceIconProps> = ({
  icon,
  alt = '',
  title,
  className = '',
  size = 'md',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = false,
}) => {
  // Handle different icon name formats:
  // - Full class: "fi fi-ts-database" or "fi-ts-database" → use as-is
  // - Simple name: "database" → convert to "fi fi-ts-database"
  let iconClass = icon;
  
  if (!icon.startsWith('fi')) {
    // Simple icon name like "database", "rocket", etc.
    // Convert to Flaticon Thin Straight format
    iconClass = `fi fi-ts-${icon}`;
  } else if (!icon.includes(' ')) {
    // Has "fi-" prefix but missing "fi " class
    iconClass = `fi ${icon}`;
  }

  return (
    <i
      className={`${iconClass} service-icon service-icon--${size} ${className}`}
      aria-label={ariaLabel || alt}
      aria-hidden={ariaHidden}
      title={title}
    />
  );
};

export default ServiceIcon;
